import { useEffect, useState, useMemo } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import Icon from "@mui/material/Icon";
import { Grid, InputAdornment, Box, Typography, Avatar } from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import axios from "axios";
import BASE_URL from "config/Base_URL";
import MyModal from "components/Modal";
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";
import { id } from "date-fns/locale";

const DataTableUser = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [listUsers, setListUsers] = useState([]);
  const token = sessionStorage.getItem("token");

  const [idUsers, setIdUsers] = useState("");
  const [name, setName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [noHp, setNoHp] = useState("");
  const [address, setAddress] = useState("");
  const [username, setUsername] = useState("");
  const [gambar, setGambar] = useState(null);

  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDetailShow, setModalDetailShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);

  // ================================================================
  //                                 DELETE
  // ================================================================

  const handleDelete = async () => {
    try {
      const response = await axios.delete(`${BASE_URL}/user/delete/${idUsers}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setModalDeleteShow(false);
      Swal.fire("Berhasil", "Users berhasil dihapus", "success");
      fetchUsers();
    } catch (error) {
      console.log(error);
      setModalDeleteShow(false);
      Swal.fire("Gagal", "Users gagal dihapus", "error");
    }
  };

  // ================================================================
  //                                 EDIT
  // ================================================================

  const handleEdit = (Users) => {
    setIdUsers(Users.id);
    setName(Users.name);
    setBusinessName(Users.businessName);
    setNoHp(Users.noHp);
    setAddress(Users.address);
    setUsername(Users.username);
    setModalEditShow(true);
  };

  const handleSubmitEdit = async () => {
    try {
      const formDataEdit = new FormData();

      formDataEdit.append("name", name);
      formDataEdit.append("businessName", businessName);
      formDataEdit.append("noHp", noHp);
      formDataEdit.append("address", address);
      formDataEdit.append("username", username);
      // formDataEdit.append("picture", "");
      formDataEdit.append("picture", new Blob([]), "");

      console.log(formDataEdit);
      const response = await axios.put(`${BASE_URL}/update/user/${idUsers}`, formDataEdit, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setModalEditShow(false);
      fetchUsers();
      Swal.fire("Berhasil", "Users berhasil diperbarui!", "success");
    } catch (error) {
      setModalEditShow(false);
      console.error("Error saat update Users:", error);
      Swal.fire("Gagal", "Gagal memperbarui Users!", "error");
    }
  };

  const renderForm = (
    <Grid container spacing={2} maxWidth="lg">
      {/* Nama Users */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            size="xxl"
            label="Nama User"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value.toUpperCase())}
            InputLabelProps={{ shrink: true }}
            required
          />
        </MDBox>
      </Grid>

      {/* businessName */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="businessName"
            variant="outlined"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value.toUpperCase())}
            InputLabelProps={{ shrink: true }}
            required
          />
        </MDBox>
      </Grid>

      {/* username */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="username"
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value.toUpperCase())}
            InputLabelProps={{ shrink: true }}
            required
          />
        </MDBox>
      </Grid>

      {/* noHp */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="noHp"
            variant="outlined"
            type="text"
            value={noHp}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/[^0-9]/g, "");
              setNoHp(onlyNums);
            }}
            required
          />
        </MDBox>
      </Grid>

      <Grid item xs={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="address Users"
            variant="outlined"
            value={address}
            onChange={(e) => setAddress(e.target.value.toUpperCase())}
            InputLabelProps={{ shrink: true }}
            multiline
            required
            rows={3}
            sx={{
              "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
              },
              "& textarea": {
                resize: "vertical",
                minHeight: "80px",
              },
            }}
          />
        </MDBox>
      </Grid>
    </Grid>
  );

  // ==================================================================
  //                               GET Users
  // ==================================================================

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setListUsers(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.error("Gagal menampilkan Users:", error);
    }
  };

  // ===================================================================
  //                                DETAIL
  // ===================================================================

  const handleDetail = async (Users) => {
    try {
      const response = await axios.get(`${BASE_URL}/users/${Users.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const UsersResponse = response.data.data;
      setIdUsers(UsersResponse.id);
      setName(UsersResponse.name);
      setBusinessName(UsersResponse.businessName);
      setNoHp(UsersResponse.noHp);
      setAddress(UsersResponse.address);
      setUsername(UsersResponse.username);

      setModalDetailShow(true);
    } catch (error) {
      console.log(error);
      Swal.fire("Gagal", "Gagal mengambil data Users!", "error");
    }
  };

  const renderFormDetail = (
    <Grid container spacing={2} maxWidth="lg">
      {/* Nama Users */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            size="xxl"
            label="Nama Users"
            variant="outlined"
            value={name}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* businessName */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            label="business Name"
            variant="outlined"
            value={businessName}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* username */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            label="username"
            variant="outlined"
            value={username}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* noHp */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            label="noHp"
            variant="outlined"
            value={noHp}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* address */}
      <Grid item xs={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            label="address Users"
            variant="outlined"
            value={address}
            InputLabelProps={{ shrink: true }}
            multiline
            rows={3}
            sx={{
              "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
              },
              "& textarea": {
                resize: "vertical",
                minHeight: "80px",
              },
            }}
          />
        </MDBox>
      </Grid>
    </Grid>
  );

  const columns = useMemo(
    () => [
      { Header: "No", accessor: "no", width: "5%", align: "left" },
      { Header: "username", accessor: "username", align: "center" },
      { Header: "Nama Users", accessor: "nama_Users", align: "center" },
      { Header: "businessName", accessor: "businessName", align: "center" },
      { Header: "noHp", accessor: "noHp", align: "center" },
      { Header: "address", accessor: "address", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],
    []
  );

  // Baris
  const rows = useMemo(
    () =>
      listUsers.map((item, index) => ({
        no: index + 1,

        username: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.username}
          </MDTypography>
        ),
        nama_Users: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.name || item.nama_Users}
          </MDTypography>
        ),
        businessName: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.businessName}
          </MDTypography>
        ),
        noHp: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.noHp}
          </MDTypography>
        ),
        address: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.description || item.address}
          </MDTypography>
        ),
        action: (
          <MDBox display="flex" alignItems="center" justifyContent="center">
            <MDBox mr={1}>
              <MDButton
                variant="text"
                color="error"
                onClick={() => {
                  setModalDeleteShow(true);
                  setIdUsers(item.id);
                }}
              >
                <Icon>delete</Icon>&nbsp;delete
              </MDButton>
            </MDBox>
            <MDBox mr={1}>
              <MDButton variant="text" color="success" onClick={() => handleEdit(item)}>
                <Icon>edit</Icon>&nbsp;edit
              </MDButton>
            </MDBox>
            <MDButton variant="text" color="info" onClick={() => handleDetail(item)}>
              <Icon>priority_high</Icon>&nbsp;detail
            </MDButton>
          </MDBox>
        ),
      })),
    [listUsers, darkMode]
  );

  const modalEdit = (
    <MyModal
      show={modalEditShow}
      onHide={() => setModalEditShow(false)}
      title="Edit Users"
      body={renderForm}
      onSubmit={handleSubmitEdit}
      submitText="Simpan"
      colorButtonSubmit="info"
    />
  );

  const modalDetail = (
    <MyModal
      show={modalDetailShow}
      onHide={() => setModalDetailShow(false)}
      title="Detail Users"
      body={renderFormDetail}
    />
  );

  const modalDelete = (
    <MyModal
      show={modalDeleteShow}
      submitText="Hapus"
      variant="danger"
      onSubmit={handleDelete}
      onHide={() => setModalDeleteShow(false)}
      colorButtonSubmit="primary"
      body="Apakah anda yakin ingin menghapus data ini?"
    />
  );

  return { columns, rows, modalEdit, modalDetail, modalDelete };
};

export default DataTableUser;
